class ArchiveFilter {
  constructor(element) {
    console.log("ArchiveFilter constructor(element)", element);

    this.element = element;
    this.parameter = element.dataset.archiveFilter;

    element.addEventListener("change", this.onChange.bind(this));
  }

  onChange(event) {
    console.log("ArchiveFilter.onChange(event)", event);

    event.preventDefault();

    let selectedValue = event.target.value;

    switch (this.parameter) {
      case "year":
        let pathParts = window.location.pathname.split("/");

        window.location.pathname = "/" + pathParts[1] + "/" + selectedValue;
        break;

      default:
        let urlParams = new URLSearchParams(window.location.search);

        if (selectedValue) {
          urlParams.set(this.parameter, selectedValue);
        } else {
          urlParams.delete(this.parameter);
        }

        urlParams.delete("s");
        urlParams.delete("page");

        window.location.search = urlParams.toString();
    }
  }
}

export default ArchiveFilter;
